<div class="ion-text-center">
  <div class="spinner-circle spinner-circle--{{color}}" [ngClass]="{'spinner-circle--static': blocked}">
    <ion-icon [name]="icon" size="large"></ion-icon>
    <div class="loader">Loading...</div>
  </div>
</div>
